let registeredSettings = [];

export const getElementSettings = () => [...registeredSettings];

export const addElementSetting = (setting) => {
  registeredSettings.push(setting);
};

export const setElementSettings = (newSettings) => {
  registeredSettings = Array.isArray(newSettings) ? [...newSettings] : [];
};
